var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error-group',{attrs:{"validator":_vm.validations,"name":"field"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var attrs = ref.attrs;
return _c('v-text-field',_vm._b({attrs:{"color":"#005c7b","label":_vm.field.label,"outlined":"","required":"","type":"time","value":_vm.newVal},on:{"input":_vm.onChange}},'v-text-field',attrs,false))}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }